import {
  ACCOUNTING_APPROVER,
  ACCOUNTING_MANAGER,
  CREATION_DATE,
  CRF_NO,
  DEPARTMENT,
  DEPARTMENT_APPROVER,
  DUE_DATE,
  EXPECTED_COMPLETION_DATE,
  ID,
  PARTICULARS,
  PO_NUMBER,
  PROJECT,
  PROJECT_CLASSES,
  RELEASING_CENTER,
  REQUESTOR,
  REQUEST_TYPE,
  STATUS,
  SUB_PROJECT,
  TOTAL_NET_PRICE,
  VENDOR
} from 'types'

import {
  formatDate,
  dateWithComma
} from 'components/downloadAsCSV/produceDownloadForSAP'

export default function ([...dataList]) {
  return dataList.map(obj => {
    const {
      requestor,
      department,
      vendor,
      project,
      departmentApprover,
      accountingApprover,
      accountingManager,
      projectClasses
    } = obj

    return {
      id: obj[ID],
      [CRF_NO]: obj[CRF_NO],
      [REQUESTOR]: `${requestor?.firstName} ${requestor?.lastName}`,
      [REQUEST_TYPE]: obj[REQUEST_TYPE],
      [CREATION_DATE]: obj[CREATION_DATE].slice(4, 21),
      [EXPECTED_COMPLETION_DATE]:
        dateWithComma(obj[EXPECTED_COMPLETION_DATE] || '') || '--',
      [DUE_DATE]: formatDate(obj[DUE_DATE]),
      [PO_NUMBER]: obj[PO_NUMBER],
      [TOTAL_NET_PRICE]: obj[TOTAL_NET_PRICE],
      [RELEASING_CENTER]: obj[RELEASING_CENTER],
      [DEPARTMENT]: department?.centerName,
      [PROJECT]: project?.projectName,
      [PROJECT_CLASSES]: projectClasses?.length,
      [VENDOR]: vendor?.bpName,
      [STATUS]: obj[STATUS],
      [DEPARTMENT_APPROVER]: `${departmentApprover?.firstName ||
        ''} ${departmentApprover?.lastName || ''}`,
      [ACCOUNTING_MANAGER]: `${accountingManager?.firstName ||
        ''} ${accountingManager?.lastName || ''}`,
      [ACCOUNTING_APPROVER]: `${accountingApprover?.firstName ||
        ''} ${accountingApprover?.lastName || ''}`,
      [PARTICULARS]: obj[PARTICULARS],
      [RELEASING_CENTER]: obj?.releasingCenter || '',
      [SUB_PROJECT]: obj[SUB_PROJECT]
    }
  })
}
